// extracted by mini-css-extract-plugin
export default {"alert":"ShowCookieAlert_alert__zVdkB"};